import React, { createContext, useContext, useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { CheckApiKey } from '../helper/CheckApiKey'
import LoadingPopup from '../components/LoadingPopup'
import PaymentService from '../services/paymentService'
import { LocalStorageManager } from '../helper/localStorage'

const StationConfigContext = createContext()

let hasFetchedConfigForApiKey = null

export const StationConfigProvider = ({ children }) => {
  const location = useLocation()
  const [stationConfig, setStationConfig] = useState(() => LocalStorageManager.getItem('stationConfig'))
  const [isFetchingConfig, setIsFetchingConfig] = useState(false)

  useEffect(() => {
    const currentApiKey = CheckApiKey()
    if (!currentApiKey) return

    const savedApiKey = LocalStorageManager.getItem('stationConfigApiKey')
    const savedConfig = LocalStorageManager.getItem('stationConfig')

    if (currentApiKey !== hasFetchedConfigForApiKey || currentApiKey !== savedApiKey) {
      setIsFetchingConfig(true)
      
      const fetchConfig = async (retryCount = 0) => {
        try {
          const res = await PaymentService.getStationConfigByApiKey(currentApiKey)
          if (res?.statusCode === 200 && res?.data) {
            const configData = Array.isArray(res.data) ? res.data[0] || null : res.data
            setStationConfig(configData)
            LocalStorageManager.setItem('stationConfig', configData)
            LocalStorageManager.setItem('stationConfigApiKey', currentApiKey)
            hasFetchedConfigForApiKey = currentApiKey
            setIsFetchingConfig(false)
          } else {
            throw new Error('Fetch failed')
          }
        } catch (error) {
          if (retryCount < 2) {
            setTimeout(() => {
              fetchConfig(retryCount + 1)
            }, 500)
          } else {
            if (currentApiKey === savedApiKey && savedConfig) {
              setStationConfig(savedConfig)
              hasFetchedConfigForApiKey = currentApiKey
            } else {
              setStationConfig(null)
              LocalStorageManager.removeItem('stationConfig')
              LocalStorageManager.removeItem('stationConfigApiKey')
            }
            setIsFetchingConfig(false)
          }
        }
      }
      
      fetchConfig()
    }
  }, [location.search])

  return (
    <StationConfigContext.Provider value={{ stationConfig, isFetchingConfig }}>
      {isFetchingConfig ? <LoadingPopup type="full" /> : children}
    </StationConfigContext.Provider>
  )
}

export const useStationConfigContext = () => {
  const context = useContext(StationConfigContext)
  if (context === undefined) {
    throw new Error('useStationConfigContext must be used within a StationConfigProvider')
  }
  return context
}
